module.exports = __webpack_public_path__ + "media/gameTronos.7c159404.mp4";